module.exports = __webpack_public_path__ + "img/9788997381340.0b7cbc71.jpg";